import { Component, Input } from '@angular/core';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-progress-wizard',
    templateUrl: './progress-wizard.component.html',
    styleUrls: ['./progress-wizard.component.scss'],
    standalone: false
})
export class ProgressWizardComponent {
    @Input() wizardObj!: IWizard;
    @Input() activeStep!: number;
    @Input() pageType!: CustomerType | string | undefined;

     apiUrl:string = environment.NODE_ENV;
     customerType = CustomerType;
     constructor(public generalService: GeneralService) { 
     }

     getTranslator(val: string): string {
          let retVal: string = this.generalService.getTranslation('Wiz_' + val,'base');
          if (retVal === undefined) {
              retVal = this.generalService.getTranslation('Wiz_' + val,'base');
          }
          return retVal;
      }
  
      openDocument(docName: string) {
          this.generalService.openDocument(docName);
      }
}
